import BaseSwitcher from '@r1-frontend/ui-react/components/controls/baseSwitcher';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { BlockContainer } from '@r1-frontend/ui-react/experimental/containers';

import { toggleHasSmartTv } from '~/src/features/tariffBuilder/actions';
import { useConstructorAnalytics } from '~/src/features/tariffBuilder/analytics/hooks/useConstructorAnalytics';
import AboutSmartTv from '~/src/features/tariffBuilder/components/popups/AboutSmartTv';
import { useCtxDispatch, useCtxSelector } from '~/src/features/tariffBuilder/hooks';

import * as ST from './styled';

const CheckSmartTvContainer = (): JSX.Element => {

    const dispatch = useCtxDispatch();

    const hasSmartTv  = useCtxSelector(state => state.hasSmartTv);

    const analytics = useConstructorAnalytics();

    const onChangeHandler = () => {
        dispatch(toggleHasSmartTv());
        if (!hasSmartTv) {
            analytics.clickedHaveSmartTvCheckBox();
        }
    };

    return (
        <BlockContainer
            indent={{ $united: [24] }}
            rounder={{ $radius: 32 }}
        >
            <ST.ContentWrapper $size={16}>
                <Paragraph4>
                    Если у вас <AboutSmartTv/>, можно отказаться от приставки, тариф будет дешевле.
                </Paragraph4>
                <ST.ControlWrapper>
                    У меня есть Smart TV
                    <BaseSwitcher
                        checked={hasSmartTv}
                        onChange={onChangeHandler}
                    />
                </ST.ControlWrapper>
            </ST.ContentWrapper>
        </BlockContainer>
    );
};

export default CheckSmartTvContainer;
